import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PolicyBillingUploadService {

  constructor(private http: HttpClient) { }

  isHaveMAGWPolicy(policyList) {
   return policyList.filter((policy) =>
      policy?.policynumber?.policyNumber?.length === 10 &&
      policy?.jurisdiction?.state === 'MA');
  }
  isMAGWPolicy(policy) {
    return this.isHaveMAGWPolicy([policy])?.length > 0;
  }
  getAutoPolicySelectList() {
   return [
      {
        'type': 'Vehicle Title/Registration Verification',
        'ecmDocCode': 'ADDDELVEH',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Proof of Good Student',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Student Away Verification',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Defensive Driver Certificate',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Proof of Sale - Auto',
        'ecmDocCode': 'ADDDELVEH',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Lienholder/ Lessor Change',
        'ecmDocCode': 'LSSPAYCHG',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Vehicle Appraisal',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Vehicle Work Order - Custom Equipment',
        'ecmDocCode': 'COVCHG',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Insurance Questionnaire',
        'ecmDocCode': 'MISCPOL',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Coverage Change Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Inspection Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Other Insurance Verification',
        'ecmDocCode': 'ADDDELVEH',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Proof of Address',
        'ecmDocCode': 'ADDDELDRVR',
        'relatedTo': 'POLICY' 
      },
      {
        'type': "Driver's License Verification",
        'ecmDocCode': 'ADDDELDRVR',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Bank Statements',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      },
      {
        'type': 'Indemnification Forms',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      }

    ]
  }
  getHO3AndHO5AndHO6SelectList() {
    return [
      {
        'type': 'Scheduled Property Appraisal',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Mortgagee Change',
        'ecmDocCode': 'MORTCHG',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Inspection Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Other Insurance Verification',
        'ecmDocCode': 'ADDDELVEH',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'American Kennel Club Registration',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Proof of Sale - Property',
        'ecmDocCode': 'CANCREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Coverage Change Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'Insurance Questionnaire',
        'ecmDocCode': 'MISCPOL',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'Bank Statements',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      },
      {
        'type': 'Indemnification Forms',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      }
    ]
  }
  getHO4SelectList() {
    return [
      {
        'type': 'Scheduled Property Appraisal',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Inspection Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Other Insurance Verification',
        'ecmDocCode': 'ADDDELVEH',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'American Kennel Club Registration',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Coverage Change Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'Insurance Questionnaire',
        'ecmDocCode': 'MISCPOL',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'Bank Statements',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      },
      {
        'type': 'Indemnification Forms',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      }
    ]
  }
  getUmbrellaSelectList() {
    return [
      {
        'type': 'Insurance Questionnaire',
        'ecmDocCode': 'MISCPOL',
        'relatedTo': 'POLICY'
      },
      {
        'type':'Family Member - Other Insurance Verification',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'Coverage Change Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'American Kennel Club Registration',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Bank Statements',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      },
      {
        'type': 'Indemnification Forms',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      }
    ]
  }

  getDP3SelectList() {
    return [
      {
        'type': 'Mortgagee Change',
        'ecmDocCode': 'MORTCHG',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Inspection Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Proof of Sale - Property',
        'ecmDocCode': 'CANCREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Coverage Change Validation',
        'ecmDocCode': 'ENDREQ',
        'relatedTo': 'POLICY' 
      },
      {
        'type': 'Insurance Questionnaire',
        'ecmDocCode': 'MISCPOL',
        'relatedTo': 'POLICY'
      },
      {
        'type': 'Bank Statements',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      },
      {
        'type': 'Indemnification Forms',
        'ecmDocCode': 'MISCBILL',
        'relatedTo': 'BILLING' 
      }
    ]
  }
  getPolicySelectList(policy) {
    const policyType = `${policy?.policyType || ''}`.toUpperCase();
    const policySubType = `${policy?.policySubType || ''}`.toUpperCase();

    if (policyType.includes('AUTO')) {
      return this.getAutoPolicySelectList();
    } else if (policyType.includes('HOME')) {
      if (policySubType === 'HO3' || policySubType === 'HO5' || policySubType === 'HO6') {
        return this.getHO3AndHO5AndHO6SelectList();
      } else if (policySubType === 'HO4') {
        return this.getHO4SelectList();
      } else if (policySubType === 'DP3') {
        return this.getDP3SelectList();
      }
    } else if (policyType.includes('UMBRELLA')) {
      return this.getUmbrellaSelectList();
    } 
  }

  uploadDocuments(type, formData, policyNumber, relatedTo, ecmDocCode): Observable<any> {
      let isLegacy;
    if (policyNumber.length === 10) {
      isLegacy = false;
    } else {
      isLegacy = true;
    }
    const url = `${environment.backend_server_url_account}/GW/${policyNumber}/${relatedTo}/documents?isLegacy=${isLegacy}&type=${type}&ecmDocCode=${ecmDocCode}`;
    return this.http.post(url, formData).pipe(
      map((response) => response),
      catchError((err) => of(err))
    );
  }
  sendDocumentUploadEmail(payload): Observable<any> {
    const url = `${environment.backend_server_url_policy}/sendDocumentUploadEmail`;
    return this.http.post(url, payload);
  }
}
